import {
  ADD_REVIEW_FORM_VALIDATION,
  RECEIVE_SUBMIT_ADD_REVIEW,
  REQUEST_SUBMIT_ADD_REVIEW,
  RESET_ADD_REVIEW,
  UPDATE_ADD_REVIEW_ABOUT,
  UPDATE_ADD_REVIEW_FIT,
  UPDATE_ADD_REVIEW_RATING,
  UPDATE_ADD_REVIEW_SUMMARY
} from 'constants/reduxActions';

const initialState = {
  summary: '',
  overallRating: '0',
  comfortRating: '0',
  lookRating: '0',
  shoeSize: 'TRUE_TO_SIZE',
  shoeWidth: 'TRUE',
  shoeArch: 'MODERATE',
  reviewerName: '',
  reviewerLocation: '',
  otherShoes: '',
  isSubmitted: false,
  isLoading: false,
  errorMap: {}
};

const addReview = (state = initialState, action) => {
  const {
    about, errorMap, fit, message, rating, summary, type
  } = action;

  switch (type) {
    case ADD_REVIEW_FORM_VALIDATION:
      return { ...state, errorMap };
    case UPDATE_ADD_REVIEW_SUMMARY:
      return { ...state, summary };
    case UPDATE_ADD_REVIEW_RATING:
      return { ...state, [rating.name]: rating.value };
    case UPDATE_ADD_REVIEW_FIT:
      return { ...state, [fit.name]: fit.value };
    case UPDATE_ADD_REVIEW_ABOUT:
      return { ...state, [about.name]: about.value };
    case REQUEST_SUBMIT_ADD_REVIEW:
      return { ...state, isLoading: true, attemptedToSubmit: true };
    case RECEIVE_SUBMIT_ADD_REVIEW:
      const nextState = { ...state, isSubmitted: true, isLoading: false };
      nextState.submitReviewErrorMessage = message;
      return nextState;
    case RESET_ADD_REVIEW:
      return initialState;
    default:
      return state;
  }
};

export default addReview;
